<form *ngIf="formPesquisa" class="d-flex align-items-center filtros-header" [formGroup]="formPesquisa">
  <mat-form-field>
    <mat-label>Cliente:</mat-label>
    <mat-select formControlName="clienteId" placeholder="Cliente">
              <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
      <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
        {{ cliente?.nome }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Data inclusão inicial:</mat-label>
    <input matInput autocomplete="off" maskDate [matDatepicker]="dataInicio" formControlName="dataInicio">
    <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
    <mat-datepicker #dataInicio></mat-datepicker>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Data inclusão final:</mat-label>
    <input matInput autocomplete="off" maskDate [matDatepicker]="dataFim" formControlName="dataFim">
    <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
    <mat-datepicker #dataFim></mat-datepicker>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Tipo status</mat-label>
    <mat-select formControlName="tipoStatus">
      <mat-option value="">Todos</mat-option>
      <mat-option *ngFor="let tps of tiposStatus" [value]="tps?.loteStatusId">
        {{ tps?.descricao }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Tipo fatura</mat-label>
    <mat-select formControlName="tipoFatura">
      <mat-option value="">Todos</mat-option>
      <mat-option *ngFor="let tp of tiposFatura" [value]="tp?.id">
        {{ tp?.descricao }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-icon-button (click)="clearFields()" matTooltip="Limpar Campos">
    <i class="fas fa-eraser eraser-button"></i>
  </button>
  <button mat-icon-button (click)="trigger()" [disabled]="formPesquisa.invalid">
    <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
  </button>
</form>
